import { render, staticRenderFns } from "./AllStaff.vue?vue&type=template&id=4a8504bd&scoped=true&"
import script from "./AllStaff.vue?vue&type=script&lang=js&"
export * from "./AllStaff.vue?vue&type=script&lang=js&"
import style0 from "./AllStaff.vue?vue&type=style&index=0&id=4a8504bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8504bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VContainer,VDataTable,VIcon,VTextField,VTooltip})
